<template>
    <div>
        <BaseAccordion :title="'Ceramic'">
            <BaseDropdown v-if="this.$route.path === '/seed'"
                          title="Part Status"
                          :options="statusOptions"
                          v-model="statusSelect"
                          @change="setStatusSelect" />
            <BaseDropdown title="Series"
                          :options="seriesOptions"
                          v-model="seriesSelect"
                          @change="setSeriesSelect" />
            <BaseDropdown title="EIA Case Size"
                          :options="sizeOptions"
                          v-model="sizeSelect"
                          @change="setSizeSelect" />
            <BaseDropdown title="Dielectric (Temp. Coef.)"
                          :options="dielectricOptions"
                          v-model="dielectricSelect"
                          @change="setDielectricSelect" />
            <BaseDropdown title="Voltage Rating (DC, except AC series)"
                          :options="voltageOptions"
                          v-model="voltageSelect"
                          @change="setVoltageSelect" />
        </BaseAccordion>
        <BaseAccordion title="Available Parts" class="e-parts">
            <CapacitorResults :items="capacitorList" />
        </BaseAccordion>
    </div>
</template>

<script lang="ts">
    import Vue from 'vue';

    import CapacitorResults from './CapacitorResults.vue';

    import { createNamespacedHelpers } from 'vuex';
    const { mapState, mapActions } = createNamespacedHelpers('ceramic');

    export default Vue.extend({
        components: {
            CapacitorResults,
        },
        mounted() {
            this.getSeriesOptions();
            this.getSizeOptions();
        },
        computed: {
            ...mapState([
                'statusSelect',
                'statusOptions',
                'seriesSelect',
                'seriesOptions',
                'sizeSelect',
                'sizeOptions',
                'dielectricSelect',
                'dielectricOptions',
                'voltageSelect',
                'voltageOptions',
                'capacitorList'
            ]),
        },
        methods: {
            ...mapActions([
                'setStatusSelect',
                'setSeriesSelect',
                'setSizeSelect',
                'setDielectricSelect',
                'setVoltageSelect',
                'getSeriesOptions',
                'getSizeOptions',
                'getDielectricOptions',
                'getVoltageOptions',
                'getCapacitors'
            ])
        },
        watch: {
            statusSelect() {
                this.getSeriesOptions();
                this.getSizeOptions();
                this.getDielectricOptions();
                this.getVoltageOptions();
                this.getCapacitors();
            },
            seriesSelect() {
                this.getSizeOptions();
                this.getDielectricOptions();
                this.getVoltageOptions();
                this.getCapacitors();
            },
            sizeSelect() {
                this.getDielectricOptions();
                this.getVoltageOptions();
                this.getCapacitors();
            },
            dielectricSelect() {
                this.getVoltageOptions();
                this.getCapacitors();
            },
            voltageSelect() {
                this.getCapacitors();
            }
        },
    })
</script>

<style>
</style>